<template>
  <div id="app">
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <nav
      class="navbar is-fixed-top has-shadow"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <div class="navbar-item" @click="showNav = false">
          <router-link to="/">
            <p
              class="is-family-secondary has-text-weight-semibold has-text-primary"
            >
              Alexandre Araújo
            </p>
          </router-link>
        </div>

        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="myNavbar"
          :class="{ 'is-active': showNav }"
          @click="showNav = !showNav"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        id="myNavbar"
        class="navbar-menu"
        :class="{ 'is-active': showNav }"
        @click="showNav = false"
      >
        <div class="navbar-start"></div>
        <div class="navbar-end">
          <router-link
            to="/"
            class="navbar-item"
            :class="{
              'is-active': this.$route.name == 'home'
            }"
          >
            Home
          </router-link>
          <!-- <router-link
            to="/skills"
            class="navbar-item"
            :class="{
              'is-active': this.$route.name == 'skills'
            }"
          >
            Skills
          </router-link> -->
          <router-link
            to="/projects"
            class="navbar-item"
            :class="{
              'is-active': this.$route.name == 'projects'
            }"
          >
            Projects
          </router-link>

          <div class="navbar-item">
            <a class="button is-info is-outlined" href="files/resume.pdf"
              >CV
            </a>
          </div>
        </div>
      </div>
    </nav>

    <section id="mainContent">
      <router-view />
    </section>
  </div>
</template>

<script>
import Database from "@/services/Database";

export default {
  name: "App",
  data() {
    return {
      showNav: false,
      projects: this.$projects
    };
  },
  async created() {
    try {
      const res = await Database.getProjects();
      this.$projects = res.data.records;
    } catch (e) {
      // console.error(e);
    }
  }
};
</script>

<style lang="sass">
@charset "utf-8"

// Import fonts
@import url('https://fonts.googleapis.com/css?family=Quicksand:500&display=swap')

// // Set your brand colors
$orange: #FF7F00
$blue: #3298dc

// // Update Bulma's global variables
$primary: $blue
$info: $orange
$navbar-item-active-color: $blue

$family-secondary: "Quicksand", sans-serif


@import "~bulma/bulma.sass"
</style>
